function goToPage(pageId) {
    var url = pageId || '/';
    window.location = '/index.php?id=' + url;
    return false;
}

function loadLogo(conf404) {
    $('.link-logo').prepend('<img src="' + conf404['logo'] + '" alt="' + $('.link-logo').data('alt') + '" />');
    $('.link-to-contact').on('click', function () {
        goToPage(conf404['contact'])
    });
    $('.link-to-search').on('click', function () {
        goToPage(conf404['search'])
    });
    $('.link-to-sitemap').on('click', function () {
        goToPage(conf404['sitemap'])
    });
}

function get404Params(url) {
    if (urlExists(url)) {
        loadScript(url, loadLogo());
    } else {
        var conf404 = {
            contact: '9',
            search:  '98',
            sitemap: '8',
            logo:    '/typo3conf/ext/stratis_site/Resources/Public/Images/logos/logo.png'
        };
        loadLogo(conf404);
    }
}
